import * as ENUM from '@/common/enum/forward/device'
import { paramsType } from '@/utils/convert'

// Zigbee参数状态
export const ENUM_RE_ZIGBEE_PARAMS_STATUS = {
  [ENUM.ENUM_ZIGBEE_PARAMS_STATUS.NO_REPORT]: {
    title: $t('device.gateway_no_report')
  },
  [ENUM.ENUM_ZIGBEE_PARAMS_STATUS.NORMAL]: {
    title: $t('device.gateway_normal')
  }
}

// 网关电源状态
export const ENUM_RE_GATEWAY_POWER_STATUS = {
  [ENUM.ENUM_POWER_STATUS.NO_POWER]: { title: $t('device.no_power_supply') },
  [ENUM.ENUM_POWER_STATUS.NORMAL]: { title: $t('device.normal_power_supply') }
}

// TCP连接状态
export const ENUM_RE_TCP_STATUS = {
  [ENUM.ENUM_TCP_STATUS.NORMAL]: { title: $t('device.conn_normal') },
  [ENUM.ENUM_TCP_STATUS.ABNORMAL]: { title: $t('device.conn_abnormal') }
}

// LTE连接状态
export const ENUM_RE_LTE_STATUS = {
  [ENUM.ENUM_LTE_STATUS.NORMAL]: { title: $t('device.LTE_conn_normal') },
  [ENUM.ENUM_LTE_STATUS.ABNORMAL]: { title: $t('device.LTE_conn_abnormal') }
}

// 飞行模式
export const ENUM_RE_AIRPLANE_MODE = {
  [ENUM.ENUM_AIRPLANE_MODE.AIRPLANE_MODE]: { title: $t('device.flight_mode') },
  [ENUM.ENUM_AIRPLANE_MODE.NO_AIRPLANE_MODE]: {
    title: $t('device.no_flight_mode')
  }
}

// 设备类型
export const ENUM_RE_DEVICE_TYPE = {
  [ENUM.ENUM_DEVICE_TYPE.SENSOR]: { code: 'sensor' },
  [ENUM.ENUM_DEVICE_TYPE.GATEWAY]: { code: 'gateway' },
  [ENUM.ENUM_DEVICE_TYPE.DISPLAY]: { code: 'display' },
  [ENUM.ENUM_DEVICE_TYPE.RELAY]: { code: 'relay' },
  [ENUM.ENUM_DEVICE_TYPE.BASE]: { code: 'plinth' }
}
// 二代zigbee工作模式
export const ENUM_RE_TWO_GEN_ZIGBEE_WORK_MODE = {
  [ENUM.ENUM_TWO_GEN_ZIGBEE_WORK_MODE.ASYNC]: { title: $t('integration.async_mode') },
  [ENUM.ENUM_TWO_GEN_ZIGBEE_WORK_MODE.SYNC]: { title: $t('integration.sync_mode') },
  [ENUM.ENUM_TWO_GEN_ZIGBEE_WORK_MODE.FIXED]: { title: $t('integration.fix_mode') }
}

// 4G传感器工作模式
export const ENUM_RE_FOUR_G_SENSOR_WORK_MODE = {
  [ENUM.ENUM_FOUR_G_SENSOR_WORK_MODE.RANGE_CHANGE_AMOUNT]: {
    title: $t('integration.interval_variation_mode')
  },
  [ENUM.ENUM_FOUR_G_SENSOR_WORK_MODE.SYNC]: {
    title: $t('integration.sync_mode')
  },
  [ENUM.ENUM_FOUR_G_SENSOR_WORK_MODE.FIXED]: { title: $t('integration.fix_mode') }
}

/**
 * 配置日志 - 配置类型
 * @type
 */
export const ENUM_RE_SENSOR_CONFIG_TYPE = paramsType
